import {
    PlusIcon,
    SyncIcon,
    TrashIcon
} from "@primer/octicons-react";
import { Box, Checkbox } from '@primer/react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Transition } from 'semantic-ui-react';
import { SF_HACHTOAN_CONGNO_DELETE_API, SF_HACHTOAN_CONGNO_INSERT_API, SF_HACHTOAN_CONGNO_UPDATE_API } from '../../api/hachToanCongNopApi';
import { ComboboxHe } from '../../components/combobox-he';
import ComboboxKhoi from '../../components/combobox-khoi';
import { ComboboxTruong } from '../../components/combobox-truong';
import { AnimationConfirm } from '../../components/confirm';
import Button from "../../components/ui/button";
import DataGrid from "../../components/data-grid";
import { IDataGridColumn } from "../../components/data-grid/type/IDataGridProps";
import TextWithEllipse from "../../components/ui/text-with-ellipse";
import { useCommonContext } from '../../contexts/common';
import { localStorageHelper } from '../../helpers/localStorage';
import { PageBaseStatus } from '../../models/pageBaseStatus';
import { sf_hachtoan_congno, sf_hachtoan_congno_viewmodel } from '../../models/response/hach-toan-cong-no/sf_hachtoan_congno';
import { actions } from '../../state/actions/actionsWrapper';
import { changeHachToanCongNoSelectionIds, changeHe, changeKhoi, changeTruong, closeHachToanCongNoDeleteConfirm, closeHachToanCongNoDetailModal, closeHachToanCongNoImportModal, closeHachToanCongNoRefundConfirm, deleteHachToanCongNoStart, loadHachToanCongNoStart, refundHachToanCongNoStart, saveHachToanCongNoStart, showHachToanCongNoDeleteConfirm, showHachToanCongNoDetailModal, showHachToanCongNoImportModal, showHachToanCongNoRefundConfirm } from '../../state/actions/hachToanCongNoActions';
import { RootState } from '../../state/reducers';
import HachToanSummary from './hach-toan-summary';
import HachToanCongNoEditModal from "./HachToanCongNoEditModal";
import { ImportHachToanModal } from './import-modal';
const HachToanCongNoPage = () => {
    const { checkAccesiableTo } = useCommonContext();
    const dispatch = useDispatch();
    const state = useSelector((x: RootState) => x.hachToan)
    const categorySource = useSelector((x: RootState) => x.categorySource);
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
    const [hoanPhiTypeId, setHoanPhiTypeId] = useState<number>(-1);
    const [danhSachHachToanSelectedIds, setDanhSachHachToanSelectedIds] = useState<number[]>([]);

    const navigate = useNavigate();
    const { status,
        sf_hachtoan_congno_viewmodels,
        sf_hachtoan_congno_editing,
        is_show_detail_modal,
        is_show_delete_confirm,
        is_show_import_modal,
        dm_he_id,
        dm_khoi_id,
        dm_truong_id,
        is_show_refund_confirm

    } = state;

    const dataSource = useMemo(() => {
        return sf_hachtoan_congno_viewmodels.filter(x => ( hoanPhiTypeId === -1 || hoanPhiTypeId === x.sf_hoanphi_type_id) && x.dm_coso_id === dm_coso_id);
    }, [hoanPhiTypeId, sf_hachtoan_congno_viewmodels, dm_coso_id])
    const grid = useRef<any>();
    const isAccessibleInsert = useMemo(() => {
        if (!checkAccesiableTo(SF_HACHTOAN_CONGNO_INSERT_API, 'POST')) return false;
        if (danhSachHachToanSelectedIds.length > 0) return false;
        return true;
    }, [checkAccesiableTo, danhSachHachToanSelectedIds]);


    const isAccessibleUpdate = useMemo(() => {
        if (!checkAccesiableTo(SF_HACHTOAN_CONGNO_UPDATE_API, 'PUT')) return false;
        return true;
    }, [checkAccesiableTo]);

    const isAccessibleDelete = useMemo(() => {
        if (!checkAccesiableTo(SF_HACHTOAN_CONGNO_DELETE_API, 'DELETE')) return false;
        if (danhSachHachToanSelectedIds.length <= 0) return false;
        return true;
    }, [checkAccesiableTo, danhSachHachToanSelectedIds]);
    const isAccessibleRefund = useMemo(() => {
        if (danhSachHachToanSelectedIds.length <= 0) return false;
        return true;
    }, [checkAccesiableTo, danhSachHachToanSelectedIds]);
    const handleReload = () => {
        dispatch(loadHachToanCongNoStart({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        }));
        localStorageHelper.setNamHocTruongKhoiFilter({
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
            nam_hoc: nam_hoc
        })
    }

    useEffect(() => {
        if (status && status === PageBaseStatus.is_need_reload)
            handleReload();
    }, [status])
    useEffect(() => {
        handleReload();
    }, [dm_he_id, dm_khoi_id, dm_truong_id, nam_hoc])

    useEffect(() => {
        if (categorySource.dm_hes.length === 0) dispatch(actions.categorySource.loadHeStart())
        if (categorySource.dm_khois.length === 0) dispatch(actions.categorySource.loadKhoiStart())
        if (categorySource.dm_truongs.length === 0) dispatch(actions.categorySource.loadDmTruongStart())
        if (categorySource.dm_namhocs.length === 0) dispatch(actions.categorySource.loadNamHocStart())

    }, [])

    const handleRefresh = () => {
        handleReload();
        onSelectionChanged([])
        setDanhSachHachToanSelectedIds([])
    }

    const handleCloseDeleteConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoDeleteConfirm())
        setDanhSachHachToanSelectedIds([])

    }, [])
    const handleCloseRefundConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoRefundConfirm())
        setDanhSachHachToanSelectedIds([])

    }, [])
    const handleShowDeleteConfirm = useCallback(() => {
        dispatch(showHachToanCongNoDeleteConfirm())

    }, [])
    const handleShowRefundConfirm = useCallback(() => {
        dispatch(showHachToanCongNoRefundConfirm())

    }, [])
    const handleConfirmRefund = useCallback(() => {
        dispatch(refundHachToanCongNoStart(danhSachHachToanSelectedIds))
        setDanhSachHachToanSelectedIds([])

    }, [danhSachHachToanSelectedIds]);

    const handleBtnInsertClick = useCallback((e: any) => {

        if (e.itemData.id === 0) {
            dispatch(showHachToanCongNoDetailModal());
        }
        if (e.itemData.id === 1) {
            dispatch(showHachToanCongNoImportModal());
        }

    }, []);
    const handleBtnEditClicked = (data: sf_hachtoan_congno_viewmodel) => {
        dispatch(showHachToanCongNoDetailModal(data));
    }

    const onSelectionChanged = useCallback((selectedRowKeys: number[]) => {
        dispatch(changeHachToanCongNoSelectionIds(selectedRowKeys))
    }, [])
    const handleConfirmDelete = useCallback(() => {
        dispatch(deleteHachToanCongNoStart(danhSachHachToanSelectedIds))
        setDanhSachHachToanSelectedIds([])
    }, [danhSachHachToanSelectedIds]);

    const handleCloseDetailModal = useCallback(() => {
        dispatch(closeHachToanCongNoDetailModal())
    }, [])
    const handleSubmitDetailModal = useCallback((data: sf_hachtoan_congno) => {
        dispatch(saveHachToanCongNoStart(data))
    }, [])

    const cellRender = (data: any) => {
        return (
            <div>
                <span
                    style={{ cursor: "pointer", color: "green" }}
                    onClick={() => {
                        handleBtnEditClicked(data);
                    }}
                >
                    <i aria-hidden="true" className="icon edit"></i>{" "}
                </span>
            </div>
        );
    };

    const columns = useMemo<IDataGridColumn[]>(() => {
        const result: Array<IDataGridColumn | false> = [
            isAccessibleUpdate && {
                id: "actions",
                caption: "Sửa",
                width: 50,
                align: "center",
                cellRender: (cellData: any) => {
                    return cellRender(cellData);
                },
            },
            {
                id: "ho_ten",
                dataField: "ho_ten",
                width: 180,
                caption: "Học sinh",
                calculateCellValue: (data: any) => [data.ho_ten, data.ma_hs].filter(Boolean).join(" "),
                cellRender: (data: any) => {
                    return (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "baseline",
                            }}
                        >
                            <Box sx={{ display: "flex" }}>
                                <Box sx={{ fontWeight: 600 }}>{data.ho_ten}</Box>
                            </Box>
                            <Box sx={{ color: "fg.muted" }}>
                                {data.ma_hs}
                            </Box>
                        </Box>
                    );
                },
            },
            {
                dataField: "ten_truong",
                id: "ten_truong",
                caption: "Trường lớp",
                width: 180,
                calculateCellValue: (data: any) =>
                    [data.ten_lop, data.ten_khoi, data.ten_he ? `Hệ ${data.ten_he}` : ""].filter(Boolean).join(", "),
                cellRender: (data: any) => {
                    return (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "baseline",
                            }}
                        >
                            <Box sx={{ display: "flex" }}>
                                <Box sx={{ fontWeight: 600 }}>{data.ten_lop}</Box>
                            </Box>
                            <Box sx={{ color: "fg.muted" }}>
                                {data.ten_khoi}, Hệ {data.ten_he}
                            </Box>
                        </Box>
                    );
                },
            },
            {
                caption: "Nội dung",
                id: "noi_dung",
                dataField: "noi_dung",
                width: 250,
                cellRender: (data: any) => (
                    <TextWithEllipse text={data.noi_dung || ""} lineNumber={1} />
                ),
            },
            {
                caption: "Tổng tiền",
                id: "tong_tien",
                dataField: "tong_tien",
                width: 120,
                align: "right",
                cellRender: (data: any) => (
                    <div style={{ whiteSpace: "pre-line", textAlign: 'right' }}>{(data.tong_tien || 0).toLocaleString()}</div>
                ),
            },
            {
                caption: "Loại",
                id: "is_hoan_tra",
                dataField: "is_hoan_tra",
                width: 110,
                cellRender: (data: any) => (
                    <div>{data.is_hoan_tra ? "Hoàn trả" : "Thu bổ sung"}</div>
                ),
            },
            {
                caption: "Đã TT",
                id: "is_da_thanh_toan",
                dataField: "is_da_thanh_toan",
                width: 100,
                align: "center",
                cellRender: (data: any) => (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Checkbox checked={data.is_da_thanh_toan === true} aria-label="Đã thanh toán" />
                    </div>
                ),
            },
            {
                caption: "Hoàn trả PH",
                id: "is_hoantra_phuhuynh",
                dataField: "is_hoantra_phuhuynh",
                width: 100,
                align: "center",
                cellRender: (data: any) => (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Checkbox checked={data.is_hoantra_phuhuynh === true} aria-label="Hoàn trả phụ huynh" />
                    </div>
                ),
            },
        ];
        return result.filter(Boolean) as IDataGridColumn[];

    }, [categorySource.dm_truongs, categorySource.dm_khois, categorySource.dm_hes, isAccessibleUpdate]);


    return (
        <React.Fragment>
            <Box sx={{ p: 2 }}>
                <Transition animation="scale" visible={true} duration={100} transitionOnMount={true}>
                    <Box>
                        <Box sx={{ m: 1 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Box sx={{ display: "flex", gap: 2 }}>
                                    <ComboboxTruong
                                        value={dm_truong_id}
                                        onValueChanged={(value) => {
                                            dispatch(changeTruong(value));
                                        }}
                                        size="small"
                                        isShowClearButton={true}
                                    />
                                    <ComboboxKhoi
                                        dm_truong_id={dm_truong_id}
                                        value={dm_khoi_id}
                                        onValueChanged={(value) => {
                                            dispatch(changeKhoi(value));
                                        }}
                                        size="small"
                                        isShowClearButton={true}
                                    />
                                    <ComboboxHe
                                        dm_khoi_id={dm_khoi_id}
                                        dm_truong_id={dm_truong_id}
                                        value={dm_he_id}
                                        onValueChanged={(value) => {
                                            dispatch(changeHe(value));
                                        }}
                                        size="small"
                                        isShowClearButton={true}
                                    />
                                </Box>

                            </Box>
                            <Box sx={{ mt: 1 }}>
                                <DataGrid
                                    keyExpr="id"
                                    title={
                                        <HachToanSummary
                                            onSelectedChanged={setHoanPhiTypeId}
                                            selectedId={hoanPhiTypeId}
                                            sf_hachtoan_congno_viewmodels={sf_hachtoan_congno_viewmodels}
                                        />
                                    }
                                    dataSource={dataSource}
                                    isLoading={status === PageBaseStatus.is_loading}
                                    exportConfig={{ enable: true, fileName: "DanhSachHachToanCongNo" }}
                                    searchEnable={true}
                                    height={window.innerHeight - 245}
                                    selection={{
                                        mode: "multiple",
                                        selectedRowKeys: danhSachHachToanSelectedIds,
                                        onSelectionChanged(keys) {
                                            setDanhSachHachToanSelectedIds(keys);
                                        },
                                    }}
                                    actionComponent={
                                        <Box sx={{ display: "flex", gap: 2 }}>
                                            <Button
                                                variant="default"
                                                size="small"
                                                leadingVisual={SyncIcon}
                                                onClick={handleRefresh}
                                                disabled={state.status === PageBaseStatus.is_loading}
                                            >
                                                Làm mới
                                            </Button>
                                            {isAccessibleInsert && (
                                                <Button
                                                    variant="primary"
                                                    size="small"
                                                    leadingVisual={PlusIcon}
                                                    onClick={() => dispatch(showHachToanCongNoDetailModal())}
                                                >
                                                    Thêm thủ công
                                                </Button>
                                            )}
                                            {isAccessibleRefund && danhSachHachToanSelectedIds.length > 0 && (
                                                <Button
                                                    variant="primary"
                                                    size="small"
                                                    leadingVisual={SyncIcon}
                                                    onClick={handleShowRefundConfirm}
                                                >
                                                    Hoàn trả PH ({danhSachHachToanSelectedIds.length})
                                                </Button>
                                            )}
                                            {isAccessibleDelete && danhSachHachToanSelectedIds.length > 0 && (
                                                <Button
                                                    variant="danger"
                                                    size="small"
                                                    leadingVisual={TrashIcon}
                                                    onClick={handleShowDeleteConfirm}
                                                >
                                                    Xóa {danhSachHachToanSelectedIds.length} quyết toán
                                                </Button>
                                            )}
                                        </Box>
                                    }
                                    filterRow={{
                                        enable: true
                                    }}
                                    columns={columns}
                                    paging={{
                                        enable: true,
                                        pageSize: 50,
                                        pageSizeItems: [50, 100, 200, 500],
                                    }}
                                />
                            </Box>

                            {/* Modal chi tiết */}
                            {is_show_detail_modal && (
                                <HachToanCongNoEditModal
                                    sf_hachtoan_congno={sf_hachtoan_congno_editing}
                                    onClose={handleCloseDetailModal}
                                    onSubmit={handleSubmitDetailModal}
                                    is_saving={status === PageBaseStatus.is_saving}
                                    nam_hoc={nam_hoc}
                                    title={`${sf_hachtoan_congno_editing ? "Sửa " : "Thêm mới "} quyết toán`}
                                    animationOf={sf_hachtoan_congno_editing ? `#btnEdit${sf_hachtoan_congno_editing.id}` : "#btnInsert"}
                                    dm_truong_id={dm_truong_id}
                                />
                            )}
                        </Box>
                    </Box>
                </Transition>
                {/* Xác nhận xóa */}
                {is_show_delete_confirm && (
                    <AnimationConfirm
                        onClose={handleCloseDeleteConfirm}
                        onConfirmed={handleConfirmDelete}
                        text={`Bạn có chắc chắn muốn xóa ${danhSachHachToanSelectedIds.length} khoản hạch toán đã chọn ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không xóa"
                        text_confirm_button="Tiếp tục xóa"
                        type="danger"
                        animationOf="#btnDelete"
                    />
                )}

                {/* Xác nhận hoàn trả */}
                {is_show_refund_confirm && (
                    <AnimationConfirm
                        onClose={handleCloseRefundConfirm}
                        onConfirmed={handleConfirmRefund}
                        text={`Bạn có chắc chắn muốn cập nhật ${danhSachHachToanSelectedIds.length} khoản hạch toán đã chọn thành Hoàn trả PH ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không"
                        text_confirm_button="Tiếp tục"
                        type="success"
                        animationOf="#btnRefund"
                    />
                )}

                {/* Modal import */}
                {is_show_import_modal && (
                    <ImportHachToanModal
                        nam_hoc={nam_hoc}
                        animationOf="#btnInsert"
                        onClose={() => dispatch(closeHachToanCongNoImportModal())}
                        onSuccess={() => {
                            dispatch(closeHachToanCongNoImportModal());
                            handleReload();
                        }}
                    />
                )}
            </Box>
        </React.Fragment >
    );
}
export default HachToanCongNoPage;
